import { GET_TYPE_TAXES } from './../constants';
import { handleActions } from "redux-actions"

export const taxesTypes  = handleActions(
  {
    [ GET_TYPE_TAXES ]: (state, action) => action.payload
  }, []
)